import { CheckBox } from '@idexx-laboratories/spot-react';
import React from 'react';
import type { CSSObjectWithLabel } from 'react-select';
import Select, { components } from 'react-select';
import { CustomElementProps } from '../../types/react-props-types';

interface Props extends CustomElementProps {
  options: any[];
  isDisabled: boolean;
  onChange: (values: string[]) => void;
  className?: string;
}

/* eslint-disable react/prop-types */
const InputOption = ({ isSelected, children, innerProps, ...http }) => (
  // @ts-ignore
  <components.Option {...http} isSelected={isSelected} innerProps={innerProps}>
    <CheckBox id='option-checkbox' checked={isSelected} label={children} />
  </components.Option>
);

const CheckboxDropDown = (props: Props): React.JSX.Element => {
  const { options, isDisabled, onChange, className } = props;

  return (
    <>
      <Select
        className={className}
        isSearchable={false}
        isMulti
        isDisabled={isDisabled}
        placeholder='Select Event Type'
        closeMenuOnSelect={false}
        onChange={opt => {
          onChange(opt.map((o: any) => o.value));
        }}
        options={options}
        components={{ Option: InputOption }}
        styles={{
          control: (base, state) =>
            ({
              ...base,
              boxShadow: state.isFocused ? '0 0 0 1px #00a7b5' : base.boxShadow,
              borderColor: state.isFocused || state.menuIsOpen ? '#00a7b5' : base.borderColor,
              backgroundColor: state.isDisabled ? '#ffffff' : base.backgroundColor,
            }) as CSSObjectWithLabel,
          menu: base => ({ ...base, zIndex: 1000 }) as CSSObjectWithLabel,
          multiValue: base =>
            ({ ...base, backgroundColor: '#33bfcc', color: 'white' }) as CSSObjectWithLabel,
          multiValueLabel: base =>
            ({ ...base, color: 'white', fontSize: 13, fontWeight: 'bold' }) as CSSObjectWithLabel,
          option: (base, state) =>
            ({
              ...base,
              backgroundColor: state.isFocused ? '#f4f6f7' : base.backgroundColor,
            }) as CSSObjectWithLabel,
        }}
      />
    </>
  );
};

export default CheckboxDropDown;
